// removed by extract-text-webpack-plugin
module.exports = {"pageSectionForm":"_2B_7Z"};